import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import MyPATFileUpload from '../../../../../components/common/MyPATFileUpload';
import Link from '@material-ui/core/Link';
import { Grid, withStyles, WithStyles } from '@material-ui/core';
import { styles } from './style';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import { dateService, MyPATDialog, MyPATMultiSearch, MyPATSelect } from '../../../../common';
import SearchBarWithChips from '../../../common/SearchBarWithChips';
import classNames from "classnames";
import * as courseManagementActions from "../../../actions/courseManagementActions";
import {Package, Template, TestDetail, TestSeriesCoursePlan} from "../../../types/interfaces/CourseBasicDetails"
import _ from 'lodash';
import MyPATUploader, { Attachment } from '../../../../common/MyPATUploader';
import MyPATUploadPreview, { convertFileOrUrlToPreviewItem } from '../../../../common/MyPATUploadPreview';
import { Error } from "@material-ui/icons";
import DropZone from '../../../../common/DropZone';
import { SCHEDULED_TEST_SAMPLE_MAIN, SCHEDULED_TEST_SAMPLE_MILESTONE, SCHEDULE_TEST_SAMPLE_FILE_URL } from '../../../Constants/constants';
import * as XLSX from 'xlsx';
import { showMsg as showAlert } from "../../../../course/actions/loaderAlert";
import { showMsg } from '../../../../goal-management/actions/goalManagementActions';
import { contentManagementAction } from '../../../reducers/contentMangementData';
import { axiosNTL } from '../../../../../services/axios';
import { TEST_TYPE_MAP } from './Constants/Constants';

enum sheetColumnsNames {
  Duration= "duration",
  MaxAttempt= "maxAttempts",
  ScheduleDate= "startDate",
  ScheduleEndDate= "endDate",
  Syllabus= "syllabus",
  TestName="name",
  Type="type",
  RevisionTime="revisionTime",
  TestId="testId",
  QuestionsCount="questionsCount"
}
interface AddScheduledTestState {
    open: boolean;
    activeRadio: string;
    selectedTemplate:Template | null;
    scheduleTestSuggestions:any [];
    attachments: Attachment[];
    selectedScheduledTests: TestDetail[];
    activeCourses: any[];
}

interface AddScheduledTestProps extends WithStyles<typeof styles>{
  classes: any,
  templates:Template [],
  existingScheduledTests:TestDetail [],
  fetchExistingScheduledTests:Function,
  onClose: any;
  onDone: any;
  addExistingTest: Function;
  isTestInAnyPhase: boolean[];
  showAlert: Function;
  scheduleTestUploadFlag: string;
  setScheduleTestUploadFlag: Function;
}

const ALLOWED_ORDER_NOTE_ATTACHMENTS = [
    "doc",
    "docx",
    "xls",
    "xlsx",
    "msword",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
class AddScheduledTestPopUp extends React.Component <AddScheduledTestProps, AddScheduledTestState>{
  upload: any = null;
  constructor(props:any) {
    super(props);
    this.state = {
        open: false,
        activeRadio: 'Upload Milestone Test',
        selectedTemplate:null,
        scheduleTestSuggestions: [],
        attachments: [],
        selectedScheduledTests: [],
        activeCourses: [],
        
      };
  }

  componentDidUpdate(prevProps:AddScheduledTestProps,prevState:AddScheduledTestState){
    if(prevProps.existingScheduledTests!==this.props.existingScheduledTests){
      this.modifyScheduleTest(this.props.existingScheduledTests);
    }

    if(prevProps.isTestInAnyPhase !== this.props.isTestInAnyPhase){
      // //console.log('is Test in ANy Phase---------->',this.props.isTestInAnyPhase )
      if(!this.props.isTestInAnyPhase.includes(true)){
        this.props.showAlert('Test date does not lie in any phase', 'error')
      }
    }
    if(prevState.activeRadio!==this.state.activeRadio){
      this.setState({attachments:[]});
    }

    if(prevProps.scheduleTestUploadFlag !== this.props.scheduleTestUploadFlag){
      //console.log('this.props.scheduleTestUploadFlag::::::::::::::>', this.props.scheduleTestUploadFlag)
      if(this.props.scheduleTestUploadFlag === 'Test already exists in the course') {
        this.props.showAlert('Test already exists in the course', 'error')
      }

      if(this.props.scheduleTestUploadFlag === 'Test Added') {
        this.props.showAlert('Test Added', 'success')
      }

    }
 }

    handleTemplateChange=(event: any)=>{
      //console.log("TARGET",event.target.value);
      const{value,name}=event.target;
      //console.log('IN Add Scheduled Test Pop Up',value)
      this.setState({selectedTemplate:event.target.value},()=>{
        this.props.fetchExistingScheduledTests(value);
      });
    }

    modifyScheduleTest=(existingScheduledTests:TestDetail [])=>{
      //console.log(existingScheduledTests);
      const scheduledTests:any =[];
      existingScheduledTests && existingScheduledTests.forEach((scheduledTest)=>{
        let test={label:scheduledTest.name,
                  value:{...scheduledTest},id:scheduledTest._id};
        scheduledTests.push(test);
      });
      this.setState({scheduleTestSuggestions:[...scheduledTests]}, () => console.log('Scheduled Test Suggestions',this.state.scheduleTestSuggestions));
    }

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleRadio = () => {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <FormControl component='fieldset' >
          <RadioGroup 
          classes={{
            root: classes.testRadioGroup,
          }}>
          <FormControlLabel
              control={<Radio color="primary" 
              onClick={(e) => this.handleRadioChange(e)} 
              name='Upload Main Test' 
              value='Upload Main Test' 
              checked={this.state.activeRadio === 'Upload Main Test'}
              />}
              label='Upload Main Test' 
            />
            <FormControlLabel  
                control={<Radio color="primary"
                            onClick={(e) => this.handleRadioChange(e)} 
                            name='Upload Milestone Test' 
                            value='Upload Milestone Test' 
                            checked={this.state.activeRadio === 'Upload Milestone Test'}
                          />} 
                label='Upload Milestone Test' 
                />
            <FormControlLabel 
                control={<Radio color="primary"
                          onClick={(e) => this.handleRadioChange(e)} 
                          name='Import Existing Tests' 
                          value='Import Existing Tests' 
                          checked={this.state.activeRadio === 'Import Existing Tests'}
                          />} 
                label='Import Existing Tests' 
                />
          </RadioGroup>
        </FormControl>
      </div>
    )
  }

  handleRadioChange = (e:any) => {
    const { name, value} = e.target;
    //console.log('::::radio change:::::',name, value)
    this.setState({
      activeRadio: `${name}`
    }, () => console.log(this.state.activeRadio))
  }

  renderSelectTemplateOptions = () => {
    let options = [];
    const{templates,classes}=this.props;
    options.push(<option value={""}>{"Select Course"}</option>);
    _.map(templates, (template: any, index: number) =>{
      const value=_.get(template,"coursePlanId._id",'');
      options.push(
        <option key={index} value={value}>
          {template.name}
        </option>
      )}
    );
    return options;
  }

  handleScheduledTest = (items: { value: any; label: string; id: string }[]) => {
    //console.log('In Handle Schedule Test')
    //console.log({ items });
    const scheduleTests: TestDetail[] = [];
    (items!==null) && items.forEach((item) => {
      scheduleTests.push(item.value);
    });
    this.setState({ selectedScheduledTests: scheduleTests }, () => console.log(':::::Selected Scheduled Tests:::::::::',this.state.selectedScheduledTests));
  }

  handleAddTestsBtn = () => {
    const { selectedScheduledTests, activeRadio } = this.state;
    this.props.addExistingTest(selectedScheduledTests, activeRadio);
    this.setState({
      selectedTemplate: null,
      scheduleTestSuggestions: []
    })
    this.handleClose();
  }

  handleTestMapping = (selectedSuggestion: Template) => {
    //console.log({selectedSuggestion})
    this.setState({
      selectedTemplate: selectedSuggestion
    }, ()=>{
      this.props.fetchExistingScheduledTests(selectedSuggestion.coursePlanId._id);
    })
  };

  renderImportTestform = () => {
    const{classes, templates}=this.props;
    const{selectedTemplate,scheduleTestSuggestions}=this.state;
    //console.log('::::::SELECTED TEMPLATE OPTIONS:::::::::::',this.renderSelectTemplateOptions());
      return (
        <>
          <Grid container justify="center" spacing={8}>
                <Grid item xs={12} className={classes.customSelect}>
                    <Typography className={classes.inputLable}>  Select A Course </Typography>
                  {/* <MyPATSelect
                      style={{width: '100%'}}
                      name="template"
                      className={classNames(classes.margin, classes.textField)}
                      // value={selectedTemplate}
                      onChange={ (e: any) => this.handleTemplateChange(e)}
                      defaultValue={"none"}
                      required
                  >
                      {this.renderSelectTemplateOptions()}
                    </MyPATSelect> */}

                    <MyPATMultiSearch
                      options={templates}
                      labelKey='name'
                      valueKey='_id'
                      onChange={this.handleTestMapping}
                      values={selectedTemplate}
                      isSearchAble
                      // isCustomFilter
                      // filtredFunction={this.getSearchResult}
                      name="course"
                      placeholderText='Search Courses'
                      showAllOptionsOnFocus
                      // error={error.creator.showError}
                      // errorText={error.creator.errorText}
                    />

                </Grid>
                <Grid item xs={12}>
                    <Typography className={classes.inputLable}>
                    Select Scheduled Tests
                  </Typography>
                    <SearchBarWithChips
                        suggestions={scheduleTestSuggestions}
                        placeholderText="Select Scheduled Tests"
                        onSelection={this.handleScheduledTest}
                        classes={{root: classes.searchBarChips}}
                        isClearable={true} 
                        backspaceRemoves={true}
                    />
                </Grid>
        </Grid>
        <Grid>
        <Button
                  variant="contained"
                  color="primary"
                  style={{
                    marginTop: "23px",
                  }}
                  onClick={this.handleAddTestsBtn}
                >
                Add Tests
                </Button>
        </Grid>
      </>  
    )
  }

  setAttachments = (attachments: Attachment[]) => {
    this.setState({
      attachments,
    });
  };

  handleDownloadClick = () => {
    const { activeRadio } = this.state;
    let url: string;
    if (activeRadio === 'Upload Main Test') {
      url = SCHEDULED_TEST_SAMPLE_MAIN;
    } else {
      url = SCHEDULED_TEST_SAMPLE_MILESTONE;
    }
    window.open(url, "_blank");
  };

  handleFile = (Files:Attachment[]) => {
    //console.log("Files",Files);
    this.props.setScheduleTestUploadFlag('')
    this.props.onClose();
   this.readExcel(Files[0]);
  };

  readExcel = (file:any) => {
    const promise = new Promise((resolve:any, reject:any) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e:any) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, {type:'buffer'});

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data);

        fileReader.onerror=((error)=>{
          reject(error)
        })
      }
    });

    promise.then((d) => {
      //console.log(d)
      this.filterTestSeriesData(d);
    })
  }

  filterTestSeriesData = (testSeries:any) => {
    //console.log(testSeries); 
    const {activeRadio} = this.state
    const validateTestId:any=[];
    const newTestSeries:TestDetail []=[];
    testSeries = testSeries.filter((test: any) => {
      for(const [field, value] of Object.entries(test)) {
        if(typeof value !== 'string' || value.trim().length > 0) {
          return true;
        }
      }
      return false;
    })
    testSeries.map((test:any)=>{
      const newTest:any={};
       if(test["Test Id"]){
           validateTestId.push({
            testId:test["Test Id"]
            })      
       }
       newTest.contentId = test["Test Id"]
       const keys=Object.keys(test);
       //console.log('KEYS:::::::::>', keys)
        for(let key of keys ){  
          let data=test[key];
          key=key.split(" ").join("");
          // @ts-ignore
          const keyActualName:string=sheetColumnsNames[key]
           if(keyActualName){
             if(keyActualName==="type"){
               data=data.toLowerCase();
               if (TEST_TYPE_MAP.hasOwnProperty(data)) {
                data = TEST_TYPE_MAP[data];
              }
             }
             if(keyActualName==='startDate'||keyActualName==='endDate'){
              data=dateService.dateInStandardJSFormat(data);
              
            }
             newTest[keyActualName]=data;
           }
        }
        //console.log(':::::::::::NEW TEST:>', newTest)
        newTestSeries.push(newTest);
        
    });
   this.props.onDone(validateTestId,newTestSeries, activeRadio)
   this.setState({attachments:[]});
   this.handleClose();
  }

  render() {
    const { open, attachments } = this.state; 
    const { classes } = this.props;
    //console.log({attachments});
    return (
      <div>
        {/* <Button variant='contained' color='primary' onClick={this.handleClickOpen}>
          Add schedued test dialog
        </Button> */}
        <span className={classes.customFileBrowse} onClick={this.handleClickOpen}>
                {/* <input type='file' id='file' /> */}
                <label 
                // htmlFor='file' 
                className={[classes.linkCTA, classes.mb18].join(' ')}>
                  <CloudUploadOutlinedIcon />
                  &nbsp; Add Scheduled Tests
                </label>
        </span>
        <MyPATDialog
          // onClose={this.handleClose}
          // aria-labelledby='customized-dialog-title'
          // open={open}
          // fullWidth={true}
          dialogOpen={open}
          dialogHasActions={true}
          dialogHeading={
            <>
              <span className={classes.requestDialogTitle}>
              Add Scheduled Tests
              </span>
            </>
          }
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.handleClose}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: 'sm',
          }}
        >
            {/* <div className={classes.root}>
              <h3 className={classes.header}> Add Scheduled Tests 
              </h3>
              <IconButton onClick={this.handleClose}>
                <CloseIcon></CloseIcon>
              </IconButton>
            </div> */}
            {/* <span className={classes.line}></span> */}
            <Grid container justify="center">
                {this.handleRadio()}
                { this.state.activeRadio === 'Import Existing Tests' &&
                  this.renderImportTestform()
                }
                { (this.state.activeRadio === 'Upload Milestone Test' || this.state.activeRadio === 'Upload Main Test') &&
                  (
                    <div style={{width: '100%'}}>
                      <MyPATUploader
                        onChange={this.setAttachments}
                        allowedFileTypes={ALLOWED_ORDER_NOTE_ATTACHMENTS}
                        initialAttachments={attachments}
                      >
                        {({
                          onItemRemove,
                          attachments,
                          loading,
                          errorMsg,
                          error,
                          handleFileChange,
                        }) => {
                          const list = attachments.map((attachment) =>
                            convertFileOrUrlToPreviewItem(attachment)
                          );
                          return (
                            <>
                              {attachments.length > 0 ? (
                                <Grid className={classes.uploadPreview}>
                                  <MyPATUploadPreview
                                    list={list}
                                    readOnly={false}
                                    onItemRemove={onItemRemove}
                                  />
      
                                  {error && (
                                    <Grid item xs={12} justify="center">
                                      <Typography
                                        className={classes.errorText}
                                        variant="caption"
                                        color="error"
                                      >
                                        <Error />
                                        {errorMsg}
                                      </Typography>
                                    </Grid>
                                  )}
                                </Grid>
                              ) : (
                                <DropZone onChange={handleFileChange}>
                                    <Grid container justify="center" className={classes.manageContainer}>
                                      <div className={classes.dragDropVideoContainer}>
                                        <Grid container justify="center">
                                          <div style={{ width: "100%" }}>
                                            <img
                                              alt="Cancel video upload"
                                              src="/assets/svg/learn/cloudUpload.svg"
                                              onClick={(e) => {
                                                this.upload.value = "";
                                                this.upload.click();
                                              }}
                                              style={{ cursor: "pointer" }}
                                            />
                                          </div>
                                          <Typography
                                            className={classes.dragDropVideoText}
                                            component="div"
                                            variant="body1"
                                            align="center"
                                          >
                                            {false
                                              ? "uploading"
                                              : "Drag and drop a file"                                         
                                            }
                                            <span className={classes.fileInfo}>Only upload .csv with max size 2 MB</span>
                                          </Typography>
                                          <input
                                            id="myInput"
                                            type="file"
                                            ref={(ref) => (this.upload = ref)}
                                            onChange={(event: any) => {
                                              //console.log(event);
                                              //  let event={target:{files:this.upload}};
                                              handleFileChange(event);
                                            }}
                                            style={{ display: "none" }}
                                          />
                                        </Grid>
                                      </div>
                                    </Grid>
                                </DropZone>
                              )}
                            </>
                          );
                        }}
                      </MyPATUploader>
                      <div className={classes.fileTypeInfo}>
                        Kindly upload data only in the sample format .CSV
                      </div>
                      <div className={classes.downloadSample}>
                        <a onClick={this.handleDownloadClick}><img alt="Download" src="/assets/svg/learn/downloadIcon.svg"/> Download Sample Format</a>
                        {/* <Link href="../../../../../ScheduleCreate(3).xlxs" target="_blank" download>Download Sample Format</Link> */}
                      </div>
                      <Grid container justify="center">
                        <Button
                          variant="contained"
                          color="primary"
                          style={{
                            marginTop: "23px",
                          }}
                          onClick={()=>{this.handleFile(attachments)}}
                          disabled={attachments.length===0}
                        >
                          Upload File
                        </Button> 
                      </Grid>
                    </div>
                  )
                }
            </Grid>
        </MyPATDialog>
      </div>
    );
  }
}

// export default withStyles(styles)(AddScheduledTest);


const mapStateToProps = (state: any) => ({
  existingScheduledTests: state.courseMangementData.courseManagementReducer.existingScheduledTests,
  isTestInAnyPhase: state.courseMangementData.contentManagementData.isTestInAnyPhase,
  scheduleTestUploadFlag: _.get(state, 'courseMangementData.contentManagementData.scheduleTestUploadFlag', '')
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchExistingScheduledTests: courseManagementActions.fetchExistingScheduledTests,
      showAlert,
      setScheduleTestUploadFlag: contentManagementAction.setScheduleTestUploadFlag
    },
    dispatch
  )


export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
) (withStyles(styles)(AddScheduledTestPopUp));
